import React from 'react';

import PageContainer from '@/components/layout/PageContainer';

import DocumentsCard from '../../components/DocumentsCard';

const TenantDashboard: React.FC = () => {
  return (
    <PageContainer title="Dashboard">
      <div className="flex flex-col lg:flex-row flex-wrap gap-6">
        <DocumentsCard className="flex-1 min-w-80 h-min" />
      </div>
    </PageContainer>
  );
};

export default TenantDashboard;
